import { IAfiliado } from './../user/user';
export class WresponseData {
    validacion_afiliado: BodyUsuario;
    tams: BodyTams;
    success: boolean;
    descargaInfoTrab: DescargaInfoTrab;
}

export class BodyUsuario {
    afiliado: IAfiliado;
    pacs: Pac[];
    empleadores: IEmpleadores;
}

export interface IEmpleadores {
    empleadoresConcurrentes: string;
    companias: ICompania[];
}

export interface ICompania {
    bp: string;
    tipoDocumento: string;
    numberoDocumento: string;
    numeroDocumentoH?: string;
    digitoVerificador?: string;
    nombre: string;
    tipoAportante: string;
    claserAportante: string;
    fechaInicioActividad: string;
    estado: string;
    fechaIngresoAfiliado: string;
    fechaInicioVigencia: string;
    fechaInicioVigenciaH?: string;
    fechaFinVigencia?: string;
    salario: string;
    sucursal: string;
    telefono: string;
    localidad: string;
    direccion: IDireccionCompania;
    empresaPrincipal: string;
}

export interface IDireccionCompania {
    ciudad: string;
}

export interface BodyTams {
    fechaExpedicion: string;
    estado: string;
    fechaEntrega: string;
    numeroTarjeta: string;
    estadoEntrega: string;
}

export interface Pac {
    nivelEducativo: string;
    relacion: Relacion;
    segundoNombre: string;
    estado: string;
    primerNombre: string;
    fechaNacimiento: string;
    fechaInicioVigencia: string;
    segundoApellido: string;
    cuotaMonetaria: CuotaMonetaria;
    edad: any;
    bp: string;
    tipoDocumento: string;
    apellido: string;
    genero: string;
    discapacidad: string;
    numeroDocumento: string;
    tarjeta: Tarjeta;
    hasMonetaryQuotaAccreditation?: any;
    mostrarBotonACM?:any;
    mostrarBotonND?:any;
    cantidadSolicitudesCompletadas?: number;
    cantidadSolicitudesEnGestion?: number;
    tieneSubsidioAsignado?: boolean;
    cantidadSolicitudesACM?: number;
}

interface Relacion {
    descripcion: string;
    codigo: string;
}

interface CuotaMonetaria {
    aplicaSubsidio: boolean;
    motivoBloqueo: string;
    salario: string;
    valorSubsidio: string;
}

interface Tarjeta {
    estado: string;
    numero: string;
    lote: string;
}

export interface DescargaInfoTrab {
    service: string;
    codeStatus: string;
    status: string;
    message: string;
    body: string;
    success: boolean;
}
